// Contract ABI (simplified - include full ABI from compilation)
export const CONTRACT_ABI = [
    "function roll(uint256 wager, uint256 choice) external payable returns (uint256)",
    "function deposit(uint256 amount) external",
    "function withdraw() external",
    "function getRequestPrice() external view returns (uint256)",
    "function getMaxAllowedWager() external view returns (uint256)",
    "function getHouseBalance() external view returns (uint256)",
    "function getHouseDepositRatio() external view returns (uint256)",
    "function getUserDepositInfo(address user) external view returns (uint256, uint256, uint256, uint256, uint256)",
    "function getRequestStatus(uint256 requestId) external view returns (bool, bool, address, uint256, address, uint256, uint256, uint256, uint256, uint256[])",
    "function getStats() external view returns (uint256, uint256, uint256)",
    "function isRequestTimedOut(uint256 requestId) external view returns (bool)",
    "function refundTimedOutRequest(uint256 requestId) external",
    "function paused() external view returns (bool)",
    "function totalDeposits() external view returns (uint256)",
    "function depositByAddress(address) external view returns (uint256)",
    "function wagerByRequestId(uint256) external view returns (uint256)",
    "function choiceByRequestId(uint256) external view returns (uint256)",
    "function requests(uint256) external view returns (address, uint256, uint256, bool, uint256, uint256, uint256[])",
    "event RandomnessRequested(uint256 indexed requestId, address indexed requester, uint256 numWords, uint256 wager, uint256 choice, uint256 timestamp, bool paidFromContract)",
    "event RandomDiceRoll(uint256 indexed requestId, address indexed requester, uint256 choice, uint256 result, uint256 wager, uint256 payout, bool won)",
    "event FundsDeposited(address indexed depositor, uint256 amount, uint256 newTotalDeposits)",
    "event DepositWithdrawn(address indexed user, uint256 depositedAmount, uint256 fairShare, uint256 taxableProfit, uint256 tax, uint256 withdrawAmount, uint256 newTotalDeposits)"
  ];
  
  // DERP Token ABI
export const DERP_ABI = [
    "function balanceOf(address account) external view returns (uint256)",
    "function allowance(address owner, address spender) external view returns (uint256)",
    "function approve(address spender, uint256 amount) external returns (bool)",
    "function decimals() external view returns (uint8)",
    "function symbol() external view returns (string)"
  ];